import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { clearAuth } from '@/containers/Login/AuthSlice'

const LOGGED_OUT_FLAG = 'outdated-session-logged-out'

interface StoredAuth {
  authTokenSession?: string
  extraRoutes?: Record<string, unknown>
}

const useOutdatedSessionLogout = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { authTokenSession, extraRoutes } = useSelector(selectAuthData) as StoredAuth
  const isOutdated = !!authTokenSession && !extraRoutes?.optInSmsUrl

  useEffect(() => {
    if (!isOutdated || sessionStorage.getItem(LOGGED_OUT_FLAG)) return

    sessionStorage.setItem(LOGGED_OUT_FLAG, '1')
    dispatch(clearAuth())
    alert(t('common:notifications.session_expired'))
    location.assign('/login')
  }, [isOutdated, dispatch, t])
}

export default useOutdatedSessionLogout
